// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar {
  position: absolute;
  z-index: 10000;
  margin-top: 3px;
}

ion-backdrop {
  z-index: 9999;
  opacity: 0;
}

ion-icon {
  margin-bottom: 15px;
  margin-top: auto;
}

.additional-icon {
  margin-left: -30px;
}`, "",{"version":3,"sources":["webpack://./src/gyzmo-commons/components/date-picker/date-picker.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,UAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ","sourcesContent":[".calendar {\r\n    position: absolute;\r\n    z-index: 10000;\r\n    margin-top: 3px;\r\n}\r\n\r\nion-backdrop {\r\n    z-index: 9999;\r\n    opacity: 0;\r\n}\r\n\r\nion-icon {\r\n    margin-bottom: 15px;\r\n    margin-top: auto;\r\n}\r\n\r\n.additional-icon {\r\n    margin-left: -30px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
